import {Image, CSSDimension, Integer, Text} from 'platform/foundation';
import {match} from 'ts-pattern';

import {isNil} from 'ramda';

interface AdServerLogoProps {
  server: string;
  maxWidth?: Integer | CSSDimension;
  maxHeight?: Integer | CSSDimension;
}

const mapServerToLogo = (server: string) =>
  match(server)
    .with('2dehands', () => '2dehands.svg')
    .with('autobazar_eu', () => 'autobazar_eu.svg')
    .with('autosupermarket_it', () => 'autosupermarket_it.svg')
    .with('autoscout24', () => 'autoscout24.svg')
    .with('automobile_it', () => 'automobile_it.svg')
    .with('autovit_ro', () => 'autovit_ro.svg')
    .with('blocket', () => 'blocket.svg')
    .with('coches_com', () => 'coches_com.svg')
    .with('coches_net', () => 'coches_net.svg')
    .with('encar_eu', () => 'encar_eu.svg')
    .with('hasznaltauto_hu', () => 'hasznaltauto_hu.svg')
    .with('kleinanzeigen', () => 'kleinanzeigen.svg')
    .with('lacentrale', () => 'lacentrale.svg')
    .with('luxauto_lu', () => 'luxauto_lu.svg')
    .with('marktplaats_nl', () => 'marktplaats_nl.svg')
    .with('mobile_de', () => 'mobile_de.svg')
    .with('otomoto_pl', () => 'otomoto_pl.svg')
    .with('sauto', () => 'sauto.svg')
    .with('tipcars', () => 'tipcars.svg')
    .with('volvo_selekt', () => 'volvo_selekt.png')
    .with('bmw_certified', () => 'bmw_certified.svg')
    .with('mercedes_benz_certified', () => 'mercedes_benz_certified.svg')
    .with('spoticar', () => 'spoticar.svg')
    .with('subito_it', () => 'subito_it.svg')
    .with('willhaben', () => 'willhaben.svg')
    .with('wallapop', () => 'wallapop.svg')
    .with('myway', () => 'myway.webp')
    .with('autoplac_pl', () => 'autoplac_pl.svg')
    .with('volkswagen_de', () => 'volkswagen_de.svg')
    .otherwise(() => null);

export function AdServerLogo(props: AdServerLogoProps) {
  const logo = mapServerToLogo(props.server);

  if (isNil(logo)) {
    return <Text>{props.server}</Text>;
  }

  return (
    <Image
      src={`/assets/images/ad-server-logo/${logo}`}
      maxWidth={props.maxWidth}
      maxHeight={props.maxHeight}
    />
  );
}
